<template>
  <div class="list-layout-container">
    <div class="left">
      <slot name="left"></slot>
    </div>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<style lang="less" scoped>
.list-layout-container {
  display: flex;
  width: 100%;
  height: 100%;
  .left {
    flex: 0 0 auto;
    overflow: hidden;
  }
  .right {
    flex: 1 1 auto;
    overflow: hidden;
  }
}
</style>